{
  "cards": [
    {
      "cobrandCode": "AMXGRN",
      "bank": "amex",
      "nameKey": "cobrand.amex.name",
      "cardNameKey": "cobrand.amex.cardName.green",
      "logo": "./assets/images/cobrand/amexAeromexico.svg",
      "includesCarryOn": false
    },
    {
      "cobrandCode": "AMXGLD",
      "bank": "amex",
      "nameKey": "cobrand.amex.name",
      "cardNameKey": "cobrand.amex.cardName.gold",
      "logo": "./assets/images/cobrand/amexGold.svg",
      "includesCarryOn": false
    },
    {
      "cobrandCode": "AMXPLT",
      "bank": "amex",
      "nameKey": "cobrand.amex.name",
      "cardNameKey": "cobrand.amex.cardName.platinum",
      "logo": "./assets/images/cobrand/amexPlatinum.svg",
      "includesCarryOn": false
    },
    {
      "cobrandCode": "SECLAS",
      "bank": "santander",
      "nameKey": "cobrand.santander.name",
      "cardNameKey": "cobrand.santander.cardName.classic",
      "logo": "./assets/images/cobrand/santanderAeromexico.svg",
      "includesCarryOn": false
    },
    {
      "cobrandCode": "SEPLAT",
      "bank": "santander",
      "nameKey": "cobrand.santander.name",
      "cardNameKey": "cobrand.santander.cardName.platinum",
      "logo": "./assets/images/cobrand/santanderPlatinum.svg",
      "includesCarryOn": false
    },
    {
      "cobrandCode": "SEIFNT",
      "bank": "santander",
      "nameKey": "cobrand.santander.name",
      "cardNameKey": "cobrand.santander.cardName.infinite",
      "logo": "./assets/images/cobrand/santanderInfinite.svg",
      "includesCarryOn": false
    },
    {
      "cobrandCode": "SFIDBT",
      "bank": "inbursa",
      "nameKey": "cobrand.inbursa.name",
      "cardNameKey": "cobrand.inbursa.cardName.debit",
      "logo": "./assets/images/cobrand/inbursaco.svg",
      "includesCarryOn": true
    },
    {
      "cobrandCode": "SFIDBT",
      "bank": "inbursa",
      "nameKey": "cobrand.inbursa.name",
      "cardNameKey": "cobrand.inbursa.cardName.debit",
      "logo": "./assets/images/cobrand/inbursaDebit.svg",
      "includesCarryOn": false
    },
    {
      "cobrandCode": "SFIASC",
      "bank": "inbursa",
      "nameKey": "cobrand.inbursa.name",
      "cardNameKey": "cobrand.inbursa.cardName.ascend",
      "logo": "./assets/images/cobrand/inbursaco.svg",
      "includesCarryOn": true
    },
    {
      "cobrandCode": "SFIASC",
      "bank": "inbursa",
      "nameKey": "cobrand.inbursa.name",
      "cardNameKey": "cobrand.inbursa.cardName.ascend",
      "logo": "./assets/images/cobrand/inbursaAscend.svg",
      "includesCarryOn": false
    },
    {
      "cobrandCode": "SFIASA",
      "bank": "inbursa",
      "nameKey": "cobrand.inbursa.name",
      "cardNameKey": "cobrand.inbursa.cardName.ascend",
      "logo": "./assets/images/cobrand/inbursaco.svg",
      "includesCarryOn": true
    },
    {
      "cobrandCode": "SFIASA",
      "bank": "inbursa",
      "nameKey": "cobrand.inbursa.name",
      "cardNameKey": "cobrand.inbursa.cardName.ascend",
      "logo": "./assets/images/cobrand/inbursaAscend.svg",
      "includesCarryOn": false
    },
    {
      "cobrandCode": "SFIELE",
      "bank": "inbursa",
      "nameKey": "cobrand.inbursa.name",
      "cardNameKey": "cobrand.inbursa.cardName.elevate",
      "logo": "./assets/images/cobrand/inbursaco.svg",
      "includesCarryOn": true
    },
    {
      "cobrandCode": "SFIELE",
      "bank": "inbursa",
      "nameKey": "cobrand.inbursa.name",
      "cardNameKey": "cobrand.inbursa.cardName.elevate",
      "logo": "./assets/images/cobrand/InbursaElevate.svg",
      "includesCarryOn": false
    },
    {
      "cobrandCode": "SFIELA",
      "bank": "inbursa",
      "nameKey": "cobrand.inbursa.name",
      "cardNameKey": "cobrand.inbursa.cardName.elevate",
      "logo": "./assets/images/cobrand/inbursaco.svg",
      "includesCarryOn": true
    },
    {
      "cobrandCode": "SFIELA",
      "bank": "inbursa",
      "nameKey": "cobrand.inbursa.name",
      "cardNameKey": "cobrand.inbursa.cardName.elevate",
      "logo": "./assets/images/cobrand/InbursaElevate.svg",
      "includesCarryOn": false
    },
    {
      "cobrandCode": "SFIHRZ",
      "bank": "inbursa",
      "nameKey": "cobrand.inbursa.name",
      "cardNameKey": "cobrand.inbursa.cardName.horizon",
      "logo": "./assets/images/cobrand/inbursaco.svg",
      "includesCarryOn": true
    },
    {
      "cobrandCode": "SFIHRZ",
      "bank": "inbursa",
      "nameKey": "cobrand.inbursa.name",
      "cardNameKey": "cobrand.inbursa.cardName.horizon",
      "logo": "./assets/images/cobrand/inbursaHorizon.svg",
      "includesCarryOn": false
    },
    {
      "cobrandCode": "SFIHRA",
      "bank": "inbursa",
      "nameKey": "cobrand.inbursa.name",
      "cardNameKey": "cobrand.inbursa.cardName.horizon",
      "logo": "./assets/images/cobrand/inbursaco.svg",
      "includesCarryOn": true
    },
    {
      "cobrandCode": "SFIHRA",
      "bank": "inbursa",
      "nameKey": "cobrand.inbursa.name",
      "cardNameKey": "cobrand.inbursa.cardName.horizon",
      "logo": "./assets/images/cobrand/inbursaHorizon.svg",
      "includesCarryOn": false
    }
  ]
}
